import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./motion";

// Shared "keep exploring" internal-link band — same grey, small-text style as
// the contextual links on the area pages. `links`: [{ label, to }].
export const ExploreLinks = ({ links, testid = "explore-links" }) => {
  if (!links?.length) return null;
  return (
    <section data-testid={testid} className="bg-[#F9F8F6] border-t border-dotted border-zinc-300">
      <div className="max-w-[1000px] mx-auto px-5 md:px-10 py-8 md:py-10 flex flex-col gap-3">
        {links.map((l, i) => (
          <Reveal key={l.to} delay={i * 0.05}>
            <Link
              to={l.to}
              data-testid={`${testid}-link-${i}`}
              className="group inline-flex items-center gap-2 font-body font-700 text-base md:text-lg text-black/80 hover:text-[#DF3226] transition-colors"
            >
              <ArrowRight size={18} className="text-[#DF3226] shrink-0 group-hover:translate-x-1 transition-transform" />
              {l.label}
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
